
export default {
  enums: [
    { id: 'OWN_PRODUCTION'},
    { id: 'CONTRACT_PRODUCTION'}
  ]
};
